import i18n from '@/i18n';

export default {
  index: {
    columnHeader: [
      {
        id: 'updateAt',
        textLabel: i18n.t('建立日期'),
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'condition',
        textLabel: i18n.t('狀態'),
        type: 'badge',
        tabletHide: false,
      },
      {
        id: 'name',
        textLabel: i18n.t('名稱'),
        type: 'text',
        tabletHide: false,
        overflowHide: true,
      },
      {
        id: 'systemSubclasses',
        textLabel: i18n.t('領域'),
        type: 'chips',
        tabletHide: false,
      },
      {
        id: 'owner',
        textLabel: i18n.t('負責人'),
        type: 'avatar',
        tabletHide: true,
      },
      {
        id: 'expiredData',
        textLabel: i18n.t('到期日'),
        type: 'time',
        tabletHide: false,
      },
    ],
    rowData: [],
  },
  tabList: [
    {
      id: "all",
      textLabel: i18n.t("全部"),
      num: 0,
    },
    {
      id: "1",
      textLabel: i18n.t("評估中"),
      num: 0,
    },
    {
      id: "3",
      textLabel: i18n.t("執行中"),
      num: 0,
    },
    {
      id: "2",
      textLabel: i18n.t("中止"),
      num: 0,
    },
    {
      id: "4",
      textLabel: i18n.t("已結案"),
      num: 0,
    },
  ],
}